import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    lang: localStorage.getItem('lang') || 'cn',
    guideStatus: localStorage.getItem('guideStatus'), // 是否触发过引导页
    readStatus: localStorage.getItem('readStatus'), // 是否已读
    contentHeight: document.documentElement.clientHeight - 172, // 内容页高度
    contentWidth: document.documentElement.clientWidth - 110, // 内容页宽度
    themeColor: localStorage.getItem('themeColor') || '#004899', // 默认背景颜色
    pdfObj: {
      api: '',
      visible: false,
    },
    tencentMapKey: '',
    tiandituMapKey: '',
  },
  modules: {
    user,
  },
  mutations: {
    updateState: (state, payload) => {
      Object.assign(state, payload);
    },
    updateLang: (state, payload) => {
      Object.assign(state, {
        lang: payload,
      });
      localStorage.setItem('lang', payload);
    },
    updateGuideStatus: (state, payload) => {
      Object.assign(state, {
        guideStatus: payload,
      });
      localStorage.setItem('guideStatus', payload);
    },
    updateReadStatus: (state, payload) => {
      Object.assign(state, {
        readStatus: payload,
      });
      localStorage.setItem('readStatus', payload);
    },
    updateThemeColor: (state, payload) => {
      Object.assign(state, {
        themeColor: payload.themeColor,
      });
      localStorage.setItem('themeColor', payload.themeColor);
    },
    updatePdf: (state, payload) => {
      state.pdfObj = Object.assign(state.pdfObj, {
        ...payload,
      });
    },
    updateTencentMapKey: (state, payload) => {
      Object.assign(state, {
        tencentMapKey: payload,
      });
    },
    updateTiandituMapKey: (state, payload) => {
      Object.assign(state, {
        tiandituMapKey: payload,
      });
    },
  },
  getters: {
    tencentMapKey: state => state.tencentMapKey,
    tiandituMapKey: state => state.tiandituMapKey,
  },
  actions: {},
});
